export const GOODS_TYPE = {
  /**
   * 마플샵제작배송 상품
   */
  MPS: 'MPS',

  /**
   * 크리에이터배송 상품
   */
  PBG: 'PBG',

  /**
   * 디지털/전자책 상품
   */
  DTG: 'DTG',

  /**
   * 입고 상품 (크리에이터배송 상품중 마플샵 위탁 배송 상품, AKA 마플샵 배송 상품)
   */
  TPL: 'TPL',
} as const;

export type GoodsTypeId = keyof typeof GOODS_TYPE;
